export const TABS = {
  PARAMS: 0,
  HEADERS: 1,
  BODY: 2,
  OPTIONS: 3,
};
